

















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ResumoProfissional } from '@/types/_'
import { formatValorBRL, ehValorNegativo, formatQuantidade } from '@/utils/formatacaoNumerica'

const maximoExpandidoPorPadrao: number = 5

@Component
export default class ComponentResumoProfissionais extends Vue {
  @Prop({ default: () => [] }) resumo: ResumoProfissional[]

  @Prop({ default: '' }) profissionalSelecionado: string

  aberto: boolean = true

  @Watch('resumo')
  onResumoChange(valor: ResumoProfissional[]) {
    this.aberto = valor.length <= maximoExpandidoPorPadrao
  }

  get profissionalAtivo() {
    return this.resumo.find(profissional => this.isAtivo(profissional.id))
  }

  // Fechado e com filtro: o cabecalho carrega o profissional ativo em vez do titulo,
  // senao o filtro fica invisivel com o bloco colapsado.
  get mostrarLinhaAtiva() {
    return !this.aberto && !!this.profissionalAtivo
  }

  get iconeColapso() {
    if (this.aberto) {
      return 'keyboard_arrow_up'
    }

    return 'keyboard_arrow_down'
  }

  isAtivo(profissionalId: string) {
    return this.profissionalSelecionado === profissionalId
  }

  ehNegativo(valor: number) {
    return ehValorNegativo(valor)
  }

  formatValor(valor: number) {
    return formatValorBRL(valor)
  }

  textoQuantidade(quantidade: number) {
    if (quantidade === 1) {
      return '1 item'
    }

    return `${formatQuantidade(quantidade)} itens`
  }

  alternar() {
    this.aberto = !this.aberto
  }

  // Clicar no profissional ja filtrado limpa o filtro, igual ao clearable do combo de filtros.
  select(profissionalId: string) {
    this.$emit('select', this.isAtivo(profissionalId) ? '' : profissionalId)
  }
}
